export default __webpack_public_path__ + "static/media/praxis2.091abbbe.webp";